'use client'

import * as React from 'react'
import { Checkbox as CheckboxPrimitive } from '@base-ui/react/checkbox'
import { CheckIcon, MinusIcon } from 'lucide-react'

import cn from '@config/tailwind/cn'

function Checkbox({ className, indeterminate, checked, ...props }: CheckboxPrimitive.Root.Props) {
  return (
    <CheckboxPrimitive.Root
      data-slot='checkbox'
      checked={checked}
      indeterminate={indeterminate}
      className={cn(
        'peer ui:relative ui:flex ui:size-6 ui:shrink-0 ui:items-center ui:justify-center ui:rounded ui:border-2 ui:border-blue-70 ui:bg-grey-10 ui:transition-colors ui:outline-none',
        'ui:data-checked:bg-blue-100 ui:data-checked:border-blue-100',
        'ui:data-indeterminate:bg-blue-100 ui:data-indeterminate:border-blue-100',
        'ui:focus-visible:border-blue-100 ui:focus-visible:ring-[3px] ui:focus-visible:ring-blue-20',
        'ui:aria-invalid:border-error ui:aria-invalid:ring-[3px] ui:aria-invalid:ring-error/20',
        'ui:disabled:cursor-not-allowed ui:disabled:opacity-50',
        'ui:group-has-disabled/field:opacity-50',
        'ui:after:absolute ui:after:-inset-x-3 ui:after:-inset-y-2',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot='checkbox-indicator'
        keepMounted
        className='ui:grid ui:place-content-center ui:text-neutral-white ui:transition-none ui:[&>svg]:size-3.5'
      >
        {(checked || indeterminate) && (indeterminate ? <MinusIcon strokeWidth={3} /> : <CheckIcon strokeWidth={3} />)}
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
